<script lang="ts" setup>
const { $t } = useLocalization();

const props = defineProps<{
    pager: Pager;
    options: Option[];
}>();

const emit = defineEmits<{
    (e: 'change', pager: Pager): void;
}>();

const pagerValue = computed(() => props.pager);

const selectedText = computed(() =>
{
    return $t(props.options.find(p => p.value == pagerValue.value.sorting)?.text || 'n/a');
});

const onChange = (): void =>
{
    emit('change', pagerValue.value);
};

const changeOrder = (): void =>
{
    pagerValue.value.order = pagerValue.value.order == 'ASC' ? 'DESC' : 'ASC';
    onChange();
};
</script>

<template>
    <IdeoDropdown
        variant="primary"
        split-variant="light"
        split-class="btn-text-normal py-2"
        class="data-sorting text-nowrap"
        right
        split
        @click.prevent="changeOrder()"
    >
        <template #button-content>
            <span v-if="!phone" class="me-2">{{ selectedText }}</span>
            <span v-if="pagerValue.order == 'ASC'" class="far fa-chevron-down" />
            <span v-if="pagerValue.order == 'DESC'" class="far fa-chevron-up" />
        </template>
        <IdeoDropdownItem v-for="item in options" :key="item.value" :active="pagerValue.sorting == item.value" @click.prevent="pagerValue.sorting = item.value; onChange()">
            {{ $t(item.text) }}
        </IdeoDropdownItem>
    </IdeoDropdown>
</template>

<style lang="scss">
.data-sorting {
    .dropdown-toggle {
        padding: 0 10px;
    }

    .dropdown-toggle::after {
        border: none !important;
        font-family: var(--fa-font-family);
        font-weight: 900;
        content: "\f0dc";
    }
}
</style>
